import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function AdminSettings() {
  const [form, setForm] = useState({
    message_template: "",
    gsheet_webhook_url: "",
    meta_pixel_id: "",
    ga4_id: "",
    cod_charge: 0,
    brand_name: "",
    privacy_note: "",
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const load = async () => {
    try {
      const { data } = await api.get("/admin/settings");
      setForm({
        message_template: data.message_template || "",
        gsheet_webhook_url: data.gsheet_webhook_url || "",
        meta_pixel_id: data.meta_pixel_id || "",
        ga4_id: data.ga4_id || "",
        cod_charge: data.cod_charge || 0,
        brand_name: data.brand_name || "Elvis Beauty",
        privacy_note: data.privacy_note || "",
      });
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.patch("/admin/settings", form);
      toast.success("Settings saved");
    } catch (err) { toast.error("Save failed"); }
    finally { setSaving(false); }
  };

  if (loading) return <div className="p-12">Loading…</div>;

  return (
    <div className="p-8 lg:p-12 max-w-3xl">
      <p className="overline">Configuration</p>
      <h1 className="editorial-h text-5xl text-brand-dark mt-2">Settings</h1>

      <form onSubmit={save} className="mt-8 space-y-6">
        <div className="bg-white border border-brand-line p-6 space-y-4">
          <p className="overline">Brand</p>
          <div>
            <Label className="overline">Brand name</Label>
            <Input className="mt-2 h-11 rounded-none border-brand-line" value={form.brand_name} onChange={(e) => setForm({ ...form, brand_name: e.target.value })} data-testid="settings-brand-name" />
          </div>
          <div>
            <Label className="overline">COD delivery charge (₹)</Label>
            <Input type="number" className="mt-2 h-11 rounded-none border-brand-line" value={form.cod_charge} onChange={(e) => setForm({ ...form, cod_charge: Number(e.target.value) })} data-testid="settings-cod-charge" />
          </div>
        </div>

        <div className="bg-white border border-brand-line p-6 space-y-4">
          <p className="overline">WhatsApp message template</p>
          <p className="text-xs text-brand-muted">Placeholders: {"{lead_ref}, {items_block}, {total}, {name}, {phone}, {alt_phone}, {concern}, {age}, {gender}, {address}, {city}, {district}, {state}, {pincode}, {payment}, {language}, {assignment_method}"}</p>
          <Textarea className="min-h-[260px] rounded-none border-brand-line font-mono text-xs" value={form.message_template} onChange={(e) => setForm({ ...form, message_template: e.target.value })} data-testid="settings-template" />
        </div>

        <div className="bg-white border border-brand-line p-6 space-y-4">
          <p className="overline">Integrations</p>
          <div>
            <Label className="overline">Google Sheets / CRM webhook URL</Label>
            <Input className="mt-2 h-11 rounded-none border-brand-line" value={form.gsheet_webhook_url} onChange={(e) => setForm({ ...form, gsheet_webhook_url: e.target.value })} placeholder="https://script.google.com/macros/s/.../exec" data-testid="settings-gsheet" />
            <p className="text-xs text-brand-muted mt-1">Each new lead is POSTed as JSON to this URL. Set up a Google Apps Script Web App and paste the URL here.</p>
          </div>
          <div className="grid sm:grid-cols-2 gap-4">
            <div>
              <Label className="overline">Meta Pixel ID</Label>
              <Input className="mt-2 h-11 rounded-none border-brand-line" value={form.meta_pixel_id} onChange={(e) => setForm({ ...form, meta_pixel_id: e.target.value })} />
            </div>
            <div>
              <Label className="overline">GA4 ID</Label>
              <Input className="mt-2 h-11 rounded-none border-brand-line" value={form.ga4_id} onChange={(e) => setForm({ ...form, ga4_id: e.target.value })} />
            </div>
          </div>
        </div>

        <div className="bg-white border border-brand-line p-6 space-y-4">
          <p className="overline">Privacy note</p>
          <Textarea className="min-h-[80px] rounded-none border-brand-line" value={form.privacy_note} onChange={(e) => setForm({ ...form, privacy_note: e.target.value })} />
        </div>

        <Button type="submit" disabled={saving} className="rounded-none bg-brand-primary text-brand-bone px-8 h-12" data-testid="settings-save">
          {saving ? "Saving…" : "Save settings"}
        </Button>
      </form>
    </div>
  );
}
